import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ROUTES } from "./ConstantRoute";
import Login from "View/Login";
import React from "react";
import UnprotectedRoutes from "Config/UnprotectedRoutes";
import ProtectedRoutes from "Config/ProtectedRoutes";
import { TopBar } from "Component/TopBar";
import NotFoundPage from "View/NotFoundPage";
import { EncryptStorage } from "encrypt-storage";
import IntentMenu from "View/IntentMenu/Home";
import CreateIntents from "View/IntentMenu/Create";
import RegisterFace from "View/Register";
import PlaygroundChat from "View/Playground";

function PathRouter() {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  return (
    <div>
      <Router>
        <Routes>
          <Route
            path={ROUTES.auth.login}
            element={
              <UnprotectedRoutes>
                <Login />
              </UnprotectedRoutes>
            }
          />
          <Route
            path={ROUTES.auth.register}
            element={
              <UnprotectedRoutes>
                <RegisterFace />
              </UnprotectedRoutes>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoutes>
                <TopBar />
              </ProtectedRoutes>
            }
          >
            <Route path={ROUTES.intent} element={<IntentMenu />} />
            <Route path={ROUTES.intent_create} element={<CreateIntents />} />
            <Route path={ROUTES.playground} element={<PlaygroundChat />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default PathRouter;
